import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import QuemSomos from './components/QuemSomos';
import Diferenciais from './components/Diferenciais';
import NiveisWhiteLabel from './components/NiveisWhiteLabel';
import PortalPay from './components/PortalPay';
import CTAForm from './components/CTAForm';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <QuemSomos />
        <Diferenciais />
        <NiveisWhiteLabel />
        <PortalPay />
        <CTAForm />
      </main>
      <Footer />
    </>
  );
}
